import React, { useState } from 'react';
import { MenuItem, TextField } from '@mui/material';
import PropTypes from 'prop-types';

Select.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  value: PropTypes.string,
  options: PropTypes.object,
  onChange: PropTypes.func,
};

function Select(props) {
  const { options = [], id, label = null, onChange = null, value = null, error, hint } = props;

  const [inputValue, setInputValue] = useState(value);

  function handleInputChange(e) {
    setInputValue(e.target.value);
    if (onChange) {
      onChange(e);
    }
  }

  return (
    <>
      <span>{label}</span>
      <TextField select id={id} variant="outlined" fullWidth size="small" onChange={handleInputChange} value={inputValue} error={error} helperText={hint}>
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.title ?? option.label}
          </MenuItem>
        ))}
      </TextField>
    </>
  );
}

export default Select;
